import React from 'react';

import styles from './header.scss';

const BaseHeader = props => {
    return (
        <div className={styles.titleSection}>
            <div className={styles.title}>
                <span className={styles.titleText} dangerouslySetInnerHTML={{ __html: props.title }} data-testid="checkout.header.title-text" />
                {props.infoButtonBasic && (
                    <React.Fragment>{props.infoButtonBasic}</React.Fragment>
                )}
            </div>
            <div className={styles.subText}>{props.subText}</div>
        </div>
    );
};

export default BaseHeader;
